import React from 'react';

import PropTypes from 'prop-types';

import './style.css';

const WITH_BANNER_CLASSNAME = 'with-banner';

class TopBanner extends React.Component {

    static VISIBLE = new Set();

    componentDidMount() {
        this.updateBodyClass();
    }

    updateBodyClass = (props = this.props) => {
        if (props.visible) {
            TopBanner.VISIBLE.add(this);
        }
        else {
            TopBanner.VISIBLE.delete(this);
        }
        if (TopBanner.VISIBLE.size > 0) {
            this.addClassToBody();
        }
        else {
            this.removeClassFromBody();
        }
    };

    componentWillReceiveProps(nextProps) {
        this.updateBodyClass(nextProps);
    }

    componentWillUnmount() {
        TopBanner.VISIBLE.delete(this);
        if (TopBanner.VISIBLE.size === 0) {
            this.removeClassFromBody();
        }
    }

    removeClassFromBody = () => {
        const body = this.getBodyElement();

        body.classList.remove(WITH_BANNER_CLASSNAME);
    };

    addClassToBody = () => {
        const body = document.getElementsByTagName('body')[0];

        body.classList.add(WITH_BANNER_CLASSNAME);
    };

    getBodyElement = () => {
        return document.getElementsByTagName('body')[0];
    };

    render() {
        if (!this.props.visible) {
            return null;
        }

        return (
            <div className="top-banner-wrapper">
                <div className="container is-fluid">
                    <div className="top-banner-content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

TopBanner.propTypes = {
    visible: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element, PropTypes.array
    ])
};

export default TopBanner;
